import { ReactNode } from "react";
import { clsx } from "clsx";


import cls from "./Label.module.scss";

export enum LabelView {
  White = "White",
}

interface LabelProps {
  className?: string;
  children: ReactNode;
  view?: LabelView;
}

export const Label = (props: LabelProps) => {
  const { className, children, view } = props;

  return <label className={clsx(cls.Label, { [cls[view]]: true }, [className])}>{children}</label>;
};
